import {
  Dispatch,
  FunctionComponent,
  SetStateAction,
  useCallback,
} from "react";
import { Form } from "@ui-kit/Form/Form";
import { useAppDispatch } from "@store/store";
import { useTranslation } from "react-i18next";
import { FormStatus } from "../../../../components/formFields/FormStatus";
import { AuthSubmitButton } from "../AuthSubmitButton/AuthSubmitButton";
import { sendSmsLoginOtpAction } from "@store/auth/actions/sendSmsLoginOtpAction";
import { AuthError } from "../AuthError/AuthError";
import { PhoneField } from "../../../../components/formFields/PhoneField/PhoneField";

interface SignInFormSmsProps {
  status: FormStatus;
  setState: Dispatch<SetStateAction<{ status: FormStatus }>>;
  disabled: boolean;
}

interface SmsForm {
  phone: string;
}

export const SignInFormSms: FunctionComponent<SignInFormSmsProps> = ({
  status,
  setState,
  disabled,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const handleSubmit = useCallback(
    async (values: SmsForm) => {
      setState({ status: "fetching" });
      try {
        await dispatch(
          sendSmsLoginOtpAction({
            phone: values.phone,
          }),
        );
        setState({ status: "idle" });
      } catch (_error) {
        setState({ status: "error" });
      }
    },
    [dispatch, setState],
  );

  return (
    <>
      <div className="form-container">
        <Form
          form={form}
          name="signInSms"
          layout="vertical"
          onFinish={handleSubmit}
          disabled={disabled}
          initialValues={{ phone: "" }}>
          <PhoneField disabled={disabled} />

          <AuthSubmitButton label={t("common.continue")} disabled={disabled} />
        </Form>
      </div>

      {status === "error" && <AuthError />}
    </>
  );
};
